<template>
  <div class="inline-flex justify-start w-full">
    <perfect-scrollbar class="border-solid border-soft rounded-lg p-4 ml-negative bg-soft"
         :class="{
           'box-shadow border-focus': focus,
           'hover:border-focus': isClickable,
           'pointer-events-none': !isClickable
         }"
    >
      <slot name="text"/>
      <slot name="footer"/>
    </perfect-scrollbar>
  </div>
</template>

<script>
import { PerfectScrollbar } from 'vue2-perfect-scrollbar'

export default {
  name: 'BoxWrapper',

  components: {
    PerfectScrollbar
  },

  props: {
    focus: {
      type: Boolean,
      default: false
    },
    isClickable: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
.box-shadow {
  // noinspection CssInvalidFunction - theme() belongs to TailWind
  box-shadow: 0 4px 11px 0 theme('colors.focus-a50');
}
</style>
